import React from 'react'

const Footer = () => {
  return (
    <>
    <footer>
        {/* <!-- Footer Start--> */}
        <div className="footer-area footer-bg footer-padding">
            <div className="container">
                <div className="row d-flex justify-content-between">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                       <div className="single-footer-caption mb-50">
                         <div className="single-footer-caption mb-30">
                             <div className="footer-tittle">
                                 <h4>About Us</h4>
                                 <div className="footer-pera">
                                     <p>Connecting communities to Local & Global opportunities! We curate diverse listings - jobs, internships, tenders - empowering you to discover and achieve your career aspirations.</p>
                                </div>
                             </div>
                         </div>

                       </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                        <div className="single-footer-caption mb-50">
                            <div className="footer-tittle">
                                <h4>Contact Info</h4>
                                <ul>
                                    <li>
                                    <p>Ejisu-Ashanti Region, Ghana.</p>
                                    </li>
                                    <li><a href="#">Phone : +233 559801548</a></li>
                                    <li><a href="#">Email : info@jobflowonline.com</a></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                        <div className="single-footer-caption mb-50">
                            <div className="footer-tittle">
                                <h4>Important Link</h4>
                                <ul>
                                    <li><a href="/">Home</a></li>
                                    <li><a href="/opportunity-listings/all">Find Jobs</a></li>
                                    <li><a href="/post-opportunity">Post Job</a></li>
                                    <li><a href="/user-account">Account</a></li>
                                    <li><a href="/privacy-policy">Privacy Policy</a></li>
                                    <li><a href="/terms-and-conditions">Terms & Conditions</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                        <div className="single-footer-caption mb-50">
                            <div className="footer-tittle">
                                <h4>Newsletter</h4>
                                <div className="footer-pera footer-pera2">
                                 <p>Be the first to receive job positions & opportunities through SMS or Email.</p>
                             </div>
                             {/* <!-- Form --> */}
                             <div className="footer-form" >
                                 <div id="mc_embed_signup">
                                     <form target="_blank" action="https://spondonit.us12.list-manage.com/subscribe/post?u=1462626880ade1ac87bd9c93a&amp;id=92a4423d01"
                                     method="get" className="subscribe_form relative mail_part">
                                         <input type="email" name="email" id="newsletter-form-email" placeholder="Email Address"
                                         className="placeholder hide-on-focus" onFocus="this.placeholder = ''"
                                         onBlur="this.placeholder = ' Email Address '" />
                                         <div className="form-icon">
                                             <button type="submit" name="submit" id="newsletter-submit"
                                             className="email_icon newsletter-submit button-contactForm"><img src={require("../assets/img/icon/form.png" )} alt="" /></button>
                                         </div>
                                         <div className="mt-10 info"></div>
                                     </form>
                                 </div>
                             </div>
                            </div>
                        </div>
                    </div>
                </div>
               {/* <!--  --> */}
               <div className="row footer-wejed justify-content-between">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                        {/* <!-- logo --> */}
                        <div className="footer-logo mb-20">
                        <a href="/"><img src={require("../assets/img/logo/logo2_footer.png")} style={{width:200}} alt="" /></a>
                        </div>
                    </div>
                    {/* <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                    <div className="footer-tittle-bottom">
                        <span>5000+</span>
                        <p>Talented Hunter</p>
                    </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                        <div className="footer-tittle-bottom">
                            <span>451</span>
                            <p>Talented Hunter</p>
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                        <div className="footer-tittle-bottom">
                            <span>568</span>
                            <p>Talented Hunter</p>
                        </div>
                    </div> */}
               </div>
            </div>
        </div>
        {/* <!-- footer-bottom area --> */}
        <div className="footer-bottom-area footer-bg">
            <div className="container">
                <div className="footer-border">
                     <div className="row d-flex justify-content-between align-items-center">
                         <div className="col-xl-10 col-lg-10 ">
                             <div className="footer-copy-right">
                                 {/* <p><!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. --> */}
  Copyright &copy;<script>document.write(new Date().getFullYear());</script> All rights reserved | This template is made with <i className="fa fa-heart" aria-hidden="true"></i> by <a href="#" target="_blank">PHG Tech Lab</a>
  {/* <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. --></p> */}
                             </div>
                         </div>
                         <div className="col-xl-2 col-lg-2">
                             <div className="footer-social f-right">
                                 <a href="#"><i className="fab fa-facebook-f"></i></a>
                                 <a href="#"><i className="fab fa-twitter"></i></a>
                                 <a href="#"><i className="fas fa-globe"></i></a>
                                 <a href="#"><i className="fab fa-behance"></i></a>
                             </div>
                         </div>
                     </div>
                </div>
            </div>
        </div>
        {/* <!-- Footer End--> */}
    </footer>
    </>
  )
}

export default Footer